import { Controller } from "@hotwired/stimulus";
import Plyr from "plyr";
import Reveal from "reveal.js/dist/reveal.js";

export default class extends Controller {
  static targets = ["player"];

  initialize() {
    this.player = null;
  }

  connect() {
    if (this.hasPlayerTarget) {
      Reveal.on("ready", (e) => {
        if (e.currentSlide === this.parentSlide) {
          this.initPlayer();
        }
      });

      Reveal.on("slidetransitionend", (e) => {
        if (e.currentSlide === this.parentSlide) {
          this.initPlayer();
        }
      });
    }
  }

  initPlayer() {
    this.player = new Plyr(this.playerTarget, {
      autoplay: false,
      clickToPlay: true,
      controls: ["play", "progress", "mute", "fullscreen"],
      // debug: true,
      loop: { active: false },
      playsinline: true,
      youtube: { cc_load_policy: 0 },
      vimeo: { texttrack: false },
      // muted: true
    });

    this.player.on("playing", () => this.play());
    this.player.on("pause", () => this.stop());
    this.player.on("ended", () => this.stop());
  }

  play() {
    this.parentSlide.classList.add("is-playing-video");
  }

  stop() {
    this.parentSlide.classList.remove("is-playing-video");
  }

  get parentSlide() {
    return this.element.closest(".reveal-full-slide, .reveal-slide, .reveal-gallery-slide");
  }
}
